import './styles/lib.scss'
import './styles/lib.styl'
import CircularImage from './components/CircularImage.vue'
import ContactUs from './components/ContactUs.vue'
import MapWrapper from './components/MapWrapper.vue'
import PriceEntry from './components/PriceEntry.vue'
import Social from './components/Social.vue'

export default {
  CircularImage,
  ContactUs,
  MapWrapper,
  PriceEntry,
  Social
}



// WEBPACK FOOTER //
// ./src/lib.js